import { createFileRoute } from '@tanstack/react-router';

import {
  WorkflowListPage,
  workflowListSearchSchema,
} from '@/features/workflows';

export const Route = createFileRoute('/workspaces/$workspaceId/workflows/')({
  // The status filter is shareable and survives a reload, so it lives in the
  // address rather than in the page's state. The list's text query does not:
  // nothing links to a search term, and every keystroke would become a history
  // entry.
  validateSearch: workflowListSearchSchema,
  component: WorkflowsRoute,
});

export function WorkflowsRoute() {
  const { workspaceId } = Route.useParams();
  const { status } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <WorkflowListPage
      workspaceId={workspaceId}
      statusFilter={status}
      onStatusFilterChange={(next) => {
        void navigate({ search: () => ({ status: next }) });
      }}
    />
  );
}
